export default {
  dbg_g_pop: 'G-POP',
  dbg_loading: 'Loading...',
  dbg_confirm: 'Confirm',
  dbg_cancel: 'Cancel',
  dbg_reset: 'Reset',
  dbg_close: 'Close',
  dbg_edit: 'Edit',
  dbg_collapse_filter: 'Collapse Filters',
  dbg_more_filter: 'More Filters',
  dbg_search_any_game: 'Search any Game',
  dbg_common_bar_chart: 'Bar Chart',
  dbg_common_line_chart: 'Line Chart',
  dbg_common_pie_chart: 'Pie Chart',
  dbg_common_table: 'Table',
  dbg_motion_capture_uploader_placeholder_text1: 'Click or drag mov, mp4 files to this area to upload.',
  dbg_motion_capture_uploader_placeholder_text2: 'It is recommended to upload videos of 15 seconds in length.',
  dbg_motion_capture_uploader_footer_text: 'Supports uploading multiple mov, mp4 files at once',
  dbg_motion_capture_release_the_mouse: 'Release the mouse',
  dbg_motion_capture_upload_files_single_count_tips: 'Up to {max} file can be uploaded at once',
  dbg_motion_capture_upload_files_multiple_count_tips: 'Up to {max} files can be uploaded at once',
  dbg_motion_capture_upload_files_type_tips: 'Uploaded file type ({mimeType}) not allowed.',
  dbg_motion_capture_upload_files_unknow_error_tips: 'Upload failed',
  dbg_download_csv: 'Download CSV',
  dbg_download_excel: 'Download Excel',
};
